import React from 'react';
import ReactPlayer from 'react-player';
const VideoPlayer = ({
  url,
  fileId,
  videoEnded
}) => {
  return /*#__PURE__*/React.createElement(ReactPlayer, {
    url: url,
    controls: true,
    width: "100%",
    height: "100%",
    onEnded: () => videoEnded && videoEnded(fileId)
  });
};
export { VideoPlayer };